/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

import PropTypes from 'util/PropTypes';

import ExploreContainerItem from './ExploreContainerItem';
import ExploreContainerItemList from './ExploreContainerItemList';
import { isAlive } from 'mobx-state-tree';


import CSSTransition from 'react-transition-group/CSSTransition';
import StartingPointsLayout from 'components/startingPoints/StartingPointsLayout';



/**
 * Class representing view implementation (using react) for ExploreContainer layout view
 * @extends ReactLayoutImplBase
 */
@observer
class ExploreContainerContent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return this.getRenderMarkup();
	}

	isModelAlive(){
		return isAlive(this.props.model);
	}

	componentDidUpdate(){
		const displayStartingPoints = this.props.model.exploreVM.isStartingPointsDisplayed();
		if( displayStartingPoints === false && this.isModelAlive() ) {
			this.props.layoutOwner._callChildrenFunction('triggerWidgetRender');
		}
	}

	getRenderMarkup() {
		const displayStartingPoints = this.props.model.exploreVM.isStartingPointsDisplayed();
		const item = {
			displayed: displayStartingPoints,
			render: (displayed) => this.renderStartingPoints(displayed),
			id: 'starting points'
		};
		return (
			<div className='explore-content__cards'>
				<ExploreContainerItem
					services={this.props.services}
					item={item}
				/>
				<ExploreContainerItemList
					layoutOwner={this.props.layoutOwner}
					services={this.props.services}
					model={this.props.model}
				/>
			</div>
		);
	}


	renderStartingPoints(selected){
		return <CSSTransition
			in={selected}
			classNames={'starting-points-page'}
			appear={true}
			mountOnEnter={true}
			unmountOnExit={false}>
			<StartingPointsLayout
				dashboardApi={this.props.dashboardApi}
				model={this.props.startingPointsVM}
				activeDataSourceId={this.props.model.exploreVM.activeDataSourceId}
				activeDataSourceModule={this.props.model.exploreVM.activeDataSourceModule}
				services={this.props.services}
				addVisCard={this.props.addVisCard} />
		</CSSTransition>;
	}

}

ExploreContainerContent.propTypes = {
	model: PropTypes.object,
	startingPointsVM: PropTypes.object,
	services: PropTypes.object,
	dashboardApi: PropTypes.object,
	layoutOwner: PropTypes.object.isRequired,
	addVisCard: PropTypes.func
};

export default ExploreContainerContent;



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreContainerContent.js